"use strict";

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty2 = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs3/core-js-stable/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _hoistNonReactStatics = _interopRequireDefault(require("hoist-non-react-statics"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _createLogger = _interopRequireDefault(require("../utils/createLogger"));
var _constants = require("../constants");
var _excluded = ["errorCategory", "version"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty2(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context2, _context3; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context2 = ownKeys(Object(t), !0)).call(_context2, function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context3 = ownKeys(Object(t))).call(_context3, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var formatErrorMessage = function formatErrorMessage(_ref) {
  var _context;
  var errorCategory = _ref.errorCategory,
    message = _ref.message,
    componentName = _ref.componentName,
    correlationId = _ref.correlationId,
    level = _ref.level,
    version = _ref.version;
  // ex: '[ui-floorplans]-v0.14.57-INFO-AppHeader-[correlationId: a-uuid]-Error doing something'
  return (0, _filter["default"])(_context = ["[".concat(errorCategory || _constants.ERROR_CATEGORY, "]"), "v".concat(version), level, componentName, correlationId ? "[correlationId: ".concat(correlationId, "]") : '', message]).call(_context, Boolean).join('-');
};
var _default = exports["default"] = function _default(WrappedComponent) {
  var name = WrappedComponent.displayName || WrappedComponent.name;
  var _info = function info(message) {
    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      correlationId = _ref2.correlationId,
      _ref2$componentName = _ref2.componentName,
      componentName = _ref2$componentName === void 0 ? name : _ref2$componentName,
      errorCategory = _ref2.errorCategory,
      version = _ref2.version;
    var infoString = formatErrorMessage({
      message: message,
      componentName: componentName,
      correlationId: correlationId,
      errorCategory: errorCategory,
      level: _constants.ERROR_LEVELS.INFO,
      version: version
    });
    // eslint-disable-next-line no-console
    console.info(infoString);
    // or we could log it to newrelic as an error
    // const logger = createLogger();
    // logger(infoString);
  };
  var _error = function error(message) {
    var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      correlationId = _ref3.correlationId,
      _ref3$componentName = _ref3.componentName,
      componentName = _ref3$componentName === void 0 ? name : _ref3$componentName,
      errorCategory = _ref3.errorCategory,
      version = _ref3.version;
    var logger = (0, _createLogger["default"])();
    var errorString = formatErrorMessage({
      message: message,
      componentName: componentName,
      correlationId: correlationId,
      errorCategory: errorCategory,
      level: _constants.ERROR_LEVELS.ERROR,
      version: version
    });
    logger(errorString);
  };
  var _serverDebug = function serverDebug(message) {
    var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref4$componentName = _ref4.componentName,
      componentName = _ref4$componentName === void 0 ? name : _ref4$componentName,
      errorCategory = _ref4.errorCategory,
      version = _ref4.version;
    var logger = (0, _createLogger["default"])();
    var debugString = formatErrorMessage({
      message: message,
      componentName: componentName,
      errorCategory: errorCategory,
      level: _constants.ERROR_LEVELS.INFO,
      version: version
    });
    logger(debugString);
  };
  var Component = function Component(_ref5) {
    var errorCategory = _ref5.errorCategory,
      version = _ref5.version,
      props = (0, _objectWithoutProperties2["default"])(_ref5, _excluded);
    return /*#__PURE__*/_react["default"].createElement(WrappedComponent, (0, _extends2["default"])({}, props, {
      logger: {
        error: function error(message, options) {
          return _error(message, _objectSpread(_objectSpread({}, options), {}, {
            errorCategory: errorCategory,
            version: version
          }));
        },
        info: function info(message, options) {
          return _info(message, _objectSpread(_objectSpread({}, options), {}, {
            errorCategory: errorCategory,
            version: version
          }));
        },
        serverDebug: function serverDebug(message, options) {
          return _serverDebug(message, _objectSpread(_objectSpread({}, options), {}, {
            errorCategory: errorCategory,
            version: version
          }));
        }
      }
    }));
  };
  (0, _hoistNonReactStatics["default"])(Component, WrappedComponent);
  Component.propTypes = {
    errorCategory: _propTypes["default"].string,
    version: _propTypes["default"].string
  };
  Component.defaultProps = {
    version: '0'
  };
  Component.displayName = name || 'withLogger';
  return Component;
};